import { flashItems } from '@/mocks/home';

const toneMap: Record<string, { dot: string; tag: string }> = {
  rise: { dot: 'bg-primary-500', tag: 'bg-primary-100 text-primary-800' },
  split: { dot: 'bg-accent-500', tag: 'bg-accent-100 text-accent-900' },
  pr: { dot: 'bg-secondary-500', tag: 'bg-secondary-100 text-secondary-900' },
  flip: { dot: 'bg-primary-400', tag: 'bg-primary-100 text-primary-800' },
  calm: { dot: 'bg-foreground-300', tag: 'bg-background-200 text-foreground-600' },
};

export default function FlashStream() {
  return (
    <section id="flash" className="py-16 md:py-28">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">FLASH FEED</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
              今日风向快讯流
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm leading-relaxed">
            按时间顺序滚动更新。每条都标注当前网友评论的主要走向，方便你一眼看懂态度变化。
          </p>
        </div>

        <div className="relative max-w-3xl">
          <span className="absolute left-[6px] top-2 bottom-2 w-px bg-background-300/70 hidden sm:block" />
          <div className="flex flex-col gap-6 md:gap-8">
            {flashItems.map((item) => {
              const tone = toneMap[item.tone] ?? toneMap.calm;
              return (
                <article key={item.title} className="relative sm:pl-10">
                  <span
                    className={`hidden sm:block absolute left-0 top-2 w-[13px] h-[13px] rounded-full ring-4 ring-background-50 ${tone.dot}`}
                  />
                  <div className="bg-background-100 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-200 transition-colors">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                      <span className="font-heading text-sm font-bold text-foreground-950">
                        {item.time}
                      </span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-label ${tone.tag}`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400 font-label ml-auto">{item.heat}</span>
                    </div>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mt-3 leading-snug">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{item.desc}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}